'use client'

import Link from 'next/link'
import { useRouter } from 'next/navigation'

type BackLinkProps = {
  href: string
  className?: string
  children: React.ReactNode
}

export function BackLink({ href, className, children }: BackLinkProps) {
  const router = useRouter()

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (window.history.length > 1) {
      e.preventDefault()
      router.back()
    }
  }

  return (
    <Link href={href} className={className} onClick={handleClick}>
      {children}
    </Link>
  )
}
